import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { ChevronDown } from 'lucide-react';
import { buildGroups, isPathActive } from './fioriNav';
import { useLanguage } from '../../contexts/LanguageContext';

// Horizontale SAP-Fiori-Top-Navigation (Desktop).
// Klick auf eine Kategorie oeffnet ein Modul-Panel mit Kacheln im Content-Bereich
// (statt eines ueberdeckenden Dropdowns). Routen/RBAC bleiben unveraendert.
export default function FioriTopNav({ user, badges = {}, activeModule, onSelectModule }) {
  const { t } = useLanguage();
  const navigate = useNavigate();
  const location = useLocation();
  const groups = buildGroups(t, user);

  const badgeFor = (item) => (item.badgeKey ? (badges[item.badgeKey] || 0) : 0);
  const routeActive = (g) =>
    g.home ? location.pathname === '/home' : g.items.some((it) => isPathActive(it.path, location));

  return (
    <nav className="fs-topnav" role="navigation" aria-label={t('fiori.nav.primary', 'Hauptnavigation')} data-testid="fiori-topnav">
      {groups.map((g) => {
        const isOpen = activeModule === g.id;
        const isActive = activeModule ? isOpen : routeActive(g);
        if (g.home) {
          return (
            <button
              key={g.id}
              className={`fs-navitem ${isActive ? 'active' : ''}`}
              onClick={() => { onSelectModule(null); navigate(g.home); }}
              data-testid={`fiori-nav-${g.id}`}
              aria-current={isActive ? 'page' : undefined}
            >
              {g.label}
            </button>
          );
        }
        const groupBadge = g.items.reduce((sum, it) => sum + badgeFor(it), 0);
        return (
          <button
            key={g.id}
            className={`fs-navitem ${isActive ? 'active' : ''}`}
            onClick={() => onSelectModule(isOpen ? null : g.id)}
            data-testid={`fiori-nav-${g.id}`}
            aria-haspopup="true"
            aria-expanded={isOpen}
          >
            {g.label}
            {groupBadge > 0 && <span className="fs-nav-badge" data-testid={`fiori-nav-badge-${g.id}`}>{groupBadge}</span>}
            <ChevronDown className={`fs-chev ${isOpen ? 'open' : ''}`} size={14} />
          </button>
        );
      })}
    </nav>
  );
}
